// extracted by mini-css-extract-plugin
module.exports = {"appointmentSuccessWrapper":"appointment_success-module__appointmentSuccessWrapper___ZrHn1","btnReturnHome":"appointment_success-module__btnReturnHome___5nfJf"};